module.exports = __webpack_public_path__ + "assets/images/C-route-sheet.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/C-route-sheet.png
// module id = 1324
// module chunks = 1